// extracted by mini-css-extract-plugin
export var circle = "_84-1";
export var exitConfirmationModal = "_84-5";
export var iframe = "_84-0";
export var offline = "_84-3";
export var online = "_84-2";
export var workstationSelectError = "_84-4";